// extracted by mini-css-extract-plugin
export default {"container":"ChatBotVideo_container__diUy8","icons":"ChatBotVideo_icons__9FePb","playPause":"ChatBotVideo_playPause__pw3dQ","fullScreen":"ChatBotVideo_fullScreen__q2ns-"};